export const LOGGED_IN_USER_REDUCER_KEY = 'loggedInUserReducer';

export const LOAD_LOGIN_ERROR = 'LOAD_LOGIN_ERROR';
export const SET_SIGNED_IN_USER = 'SET_SIGNED_IN_USER';
export const MFA_CHALLENGE_REQUIRED = 'MFA_CHALLENGE_REQUIRED';
export const MFA_ENROLMENT_REQUIRED = 'MFA_ENROLMENT_REQUIRED';
export const MFA_SECRET_READY = 'MFA_SECRET_READY';
export const MFA_ENROLLED = 'MFA_ENROLLED';
export const MFA_REMOVED = 'MFA_REMOVED';

const defaultState = {
  userInfo: {},
};

export default function(state = defaultState, action = {}) {
  switch (action.type) {
    case SET_SIGNED_IN_USER: {
      // The profile returned by the Portal's /me endpoint after a Firebase
      // sign-in. It never carries a token.
      const {
        id,
        email,
        firstName,
        lastName,
        role,
        countryFilter,
        imageUrl,
        advertisers,
      } = action.payload;

      return Object.assign({}, state, {
        userInfo: {
          id,
          email,
          firstName,
          lastName,
          role,
          countryFilter,
          imageUrl,
          advertisers,
        },
      });
    }
    default:
      return state;
  }
}

export const selectLoggedInUser = (state) => {
  return state[LOGGED_IN_USER_REDUCER_KEY].userInfo;
};

export const selectLoggedInUserRoles = (state) => {
  return [state[LOGGED_IN_USER_REDUCER_KEY].userInfo.role];
};
